(ns kyber.components.form-fields.select
  (:require
   [reagent-form.utils :as rfu]

   [kyber.components.composite.select :as select]
   [kyber.i18n.core :as i18n]))

(def no-value :select-no-value)

(defn- no-value->nil
  [value]
  (when-not (= no-value value)
    value))

(defn required
  [value]
  (not= no-value value))

(defn add-select-an-option
  ([options]
   (add-select-an-option options {:display (i18n/t* ::add-select-option-display)}))
  ([options {:keys [display]}]
   (into [{:value :none :display display}] options)))

(defn render
  [{:keys [node form-state]}]
  (let [params
        (second node)

        {:keys [custom-display
                default-errors
                default-hints
                default-value
                field-key
                hint-triggers
                on-change
                options
                style
                list-styles
                validators
                transformers]
         :or {default-value true
              on-change identity}}
        (:rf/custom-field params)]

    (rfu/ensure-field-key-or-throw field-key node)

    (rfu/initialize-field! form-state
                           field-key
                           {:default-errors (or default-errors [])
                            :default-hints (or default-hints [])
                            :default-value default-value
                            :hint-triggers (or hint-triggers [])
                            :masks []
                            :transformers (cond-> [no-value->nil]
                                            (some? transformers)
                                            (into transformers))
                            :validators (or validators [])})
    (fn [{:keys [form-state]}]
      [select/render
       (cond-> {:on-change #(do
                              (on-change ((apply comp (or transformers [])) %))
                              (rfu/update-field-value! form-state field-key %)

                              (when (seq (rfu/get-field-errors @form-state
                                                               field-key))
                                (rfu/validate-field! form-state field-key)))
                :default-value default-value
                :options options}
         (some? custom-display)
         (assoc :custom-display custom-display)

         (some? style)
         (assoc :style style)

         (some? list-styles)
         (assoc :list-styles list-styles))])))
